import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import TourStats from "components/other-cards/TourStats.js";
import TourCard from "components/home-cards/TourCard";
import FooterCard from "components/footers/PageFooter";
import PageHeader from "components/headers/PageHeader";
import EnquiryCard from "components/home-cards/EnquiryCard";

export default () => {
  useEffect(() => {
    document.body.style.overflow = 'auto'
  });
  return (
    <AnimationRevealPage>
      <PageHeader pageName="Tour Packages" titleName="" />
      <TourStats />
      <TourCard />
      <EnquiryCard />
      <FooterCard />
    </AnimationRevealPage>
  );
};
